import { render, staticRenderFns } from "./KayakOfferListItem.vue?vue&type=template&id=143b77c5&scoped=true&"
import script from "./KayakOfferListItem.vue?vue&type=script&lang=js&"
export * from "./KayakOfferListItem.vue?vue&type=script&lang=js&"
import style0 from "./KayakOfferListItem.vue?vue&type=style&index=0&id=143b77c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b77c5",
  null
  
)

export default component.exports